import React, {useState, useEffect, useReducer} from 'react';
import PublicNavigation from './PublicNavigation';
import AdminNavigation from './AdminNavigation';

function RootNavigation(props) {

  // const [isAdmin, setIsAdmin] = useState(false);

  // const isAdminLoggedIn = () => {
  //   const user = localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user")) : "";
  //   console.log(user);
  //   if ( user === process.env.REACT_APP_ADMIN_1 || user === process.env.REACT_APP_ADMIN_2) {
  //     setIsAdmin(true);
  //   }
  // }

  // useEffect(
  //   () => {
  //     const user = localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user")) : "";
  //     console.log(user);
  //     if ( user === process.env.REACT_APP_ADMIN_1 || user === process.env.REACT_APP_ADMIN_2) {
  //       setIsAdmin(true);
  //     }
  // }, []);

  let currentUser = null;
  if (JSON.parse(window.localStorage.getItem('user'))) {
    currentUser = JSON.parse(window.localStorage.getItem('user'))['email'] || null;
  }

  if (currentUser === process.env.REACT_APP_ADMIN_1 || currentUser === process.env.REACT_APP_ADMIN_2) {
    return <AdminNavigation/>
  } else {
    return <PublicNavigation/>
  }
}

export default RootNavigation;

